// @flow

import ajax from 'services/ajax/ajax';
import url from '@active/awe-ui-core/lib/services/url';

export const list = (
  param: { before: string, offset: number, limit: number },
  mapSuccess: Function,
  mapFailure: ?Function,
) => ajax.get(
  url('/results/events')
    .appendParam('before', param.before)
    .appendParam('offset', param.offset)
    .appendParam('limit', param.limit)
    .value(),
  { mapSuccess, mapFailure });

export const getEventResult = (
  param: { applicationName: string, divisionId: number, courseId: number, offset: number, limit: number },
  mapSuccess: Function,
  mapFailure: ?Function,
) => ajax.get(
  url(`/results/events/${param.applicationName}/participants`)
    .appendParam('groupId', param.divisionId)
    .appendParam('routeId', param.courseId)
    .appendParam('offset', param.offset)
    .appendParam('limit', param.limit)
    .value(),
  { mapSuccess, mapFailure });

export const getLeaderBoardResult = (
  param: { applicationName: string, divisionId: number, courseId: number },
  mapSuccess: Function,
  mapFailure: ?Function,
) => ajax.get(
  url(`/results/events/${param.applicationName}/leaderboard`)
    .appendParam('groupId', param.divisionId)
    .appendParam('routeId', param.courseId)
    .value(),
  { mapSuccess, mapFailure });

export const get = (
  applicationName: string,
  mapSuccess: Function,
  mapFailure: ?Function,
) => ajax.get(`/results/events/${applicationName}`, {
  mapSuccess,
  mapFailure,
});

export const save = (
  eventData: {},
  mapSuccess: Function,
  mapFailure: ?Function,
) => {
  const config = {
    url: '/results/events',
    headers: {
      'Content-Type': 'application/vnd.active.results-service.v1+json',
    },
    body: JSON.stringify(eventData),
  };
  return ajax.post(config, { mapSuccess, mapFailure });
};
